import { i18nMark } from 'lingui-react';

const messages = {
  modalTitle: i18nMark('Diagnostics Details'),
  noFaults: i18nMark('Not available. Please check again later.'),
  title: i18nMark('Diagnostics'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/DiagnosticsWidget/DiagnosticsComponent/messages.js